import multiRequest from '../shared/multiRequest';

function getNews() {
  return multiRequest([
    {
      url: 'contentful/news',
    },
  ]);
}

function getLastNews() {
  return multiRequest([
    {
      url: 'contentful/news/last',
    },
  ]);
}

const NewsService = {
  getNews,
  getLastNews,
};

export default NewsService;
